import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = [ "results", "form", "requestId" ]

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      Rails.fire(this.formTarget, 'submit')
    }, 500)
  }

  tagRequest() {
    this.latestRequestId = (this.latestRequestId || 0) + 1
    this.requestIdTarget.value = this.latestRequestId
  }

  handleResults(event) {
    let [_data, _status, xhr] = event.detail;
    const newUrl = xhr.responseURL;
    const responseRequestId = new URL(newUrl).searchParams.get('request_id')

    if (responseRequestId !== String(this.latestRequestId)) return

    history.pushState({}, null, newUrl);
    Turbo.renderStreamMessage(xhr.response);
  }
}
